function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Shop = function Shop(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 130 130",
    a11yTitle: "Shop"
  }, props), React.createElement("style", {
    type: "text/css"
  }), React.createElement("g", null, React.createElement("path", {
    "class": "st0",
    d: "M107.1,88c1.9,0,3.6-1.2,4.2-3L128,32.2c0.4-1.3,0.2-2.8-0.6-3.9c-0.8-1.1-2.1-1.8-3.5-1.8H34l-3.9-10.8 c-0.4-1.2-1.3-2.1-2.5-2.6L7.7,5.3C5.5,4.4,2.9,5.5,2.1,7.8s0.2,4.8,2.5,5.7l18.1,7.1l22.1,61.6l-8.4,16.2c-0.7,1.3-0.6,3,0.2,4.3 c0.8,1.3,2.2,2.1,3.7,2.1h0.7c-0.2,0.4-0.4,0.8-0.6,1.2c-0.7,1.7-1.1,3.5-1.1,5.4s0.4,3.7,1.1,5.4c0.7,1.6,1.7,3.1,3,4.4 c1.3,1.3,2.7,2.3,4.4,2.9c1.7,0.7,3.5,1.1,5.4,1.1s3.7-0.4,5.4-1.1c1.6-0.7,3.1-1.7,4.4-2.9c1.3-1.3,2.3-2.7,3-4.4 c0.7-1.7,1.1-3.5,1.1-5.4s-0.4-3.7-1.1-5.4c-0.2-0.4-0.4-0.8-0.6-1.2h22.3c-0.2,0.4-0.4,0.8-0.6,1.2c-0.7,1.7-1.1,3.5-1.1,5.4 s0.4,3.7,1.1,5.4c0.7,1.6,1.7,3.1,2.9,4.4c1.3,1.3,2.7,2.3,4.4,2.9c1.7,0.7,3.5,1.1,5.4,1.1s3.7-0.4,5.4-1.1 c1.6-0.7,3.1-1.7,4.4-2.9c1.3-1.3,2.3-2.7,2.9-4.4c0.7-1.7,1.1-3.5,1.1-5.4s-0.4-3.7-1.1-5.4c-0.2-0.4-0.4-0.8-0.6-1.2h3.6 c2.4,0,4.4-1.9,4.4-4.4s-1.9-4.4-4.4-4.4h-68l4.1-7.9L107.1,88L107.1,88z M84.7,79.3h-13l-1.9-18.4h16.9L84.7,79.3z M96.6,35.2 h21.3L112,53.7H94.7L96.6,35.2z M93.9,60.8h15.8l-5.9,18.4h-12L93.9,60.8z M89.4,35.2l-2,18.4H69.1l-1.9-18.4 C67.2,35.2,89.4,35.2,89.4,35.2z M43.7,53.7l-6.6-18.4H60l1.9,18.4C61.9,53.7,43.7,53.7,43.7,53.7z M59.7,111.2 c0,3.7-3,6.6-6.6,6.6s-6.6-3-6.6-6.6c0-3.4,2.5-6.2,5.8-6.6h1.7C57.2,105,59.7,107.8,59.7,111.2z M106.3,111.2c0,3.7-3,6.6-6.6,6.6 s-6.6-3-6.6-6.6c0-3.4,2.5-6.2,5.8-6.6h1.7C103.7,105,106.3,107.8,106.3,111.2z M46.3,60.8h16.3l1.9,18.4H52.9L46.3,60.8z"
  })));
};